var _effectorFileName = "/builds/gmini/front-ui-kit/src/Page403/KeyIcon.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const KeyIcon = ({
  color = '#353B60',
  ...other
}) => /*#__PURE__*/_jsxs("svg", {
  width: "24",
  height: "30",
  viewBox: "0 0 24 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: [/*#__PURE__*/_jsx("rect", {
    x: "9.32532",
    y: "8.9165",
    width: "20.0218",
    height: "2.00218",
    rx: "1.00109",
    transform: "rotate(58.1973 9.32532 8.9165)",
    fill: "#353B60"
  }), /*#__PURE__*/_jsx("rect", {
    x: "19.1733",
    y: "24.7983",
    width: "4.67176",
    height: "2.00218",
    rx: "1.00109",
    transform: "rotate(148.197 19.1733 24.7983)",
    fill: "#353B60"
  }), /*#__PURE__*/_jsx("rect", {
    x: "17.4147",
    y: "21.9619",
    width: "3.33697",
    height: "2.00218",
    rx: "1.00109",
    transform: "rotate(148.197 17.4147 21.9619)",
    fill: "#353B60"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "6.89181",
    cy: "6.89184",
    r: "4.00437",
    transform: "rotate(58.1973 6.89181 6.89184)",
    stroke: "#353B60",
    strokeWidth: "2.00218"
  })]
});